module.exports = __webpack_public_path__ + "img/borderEdgeShapeWhite.585bc45a.svg";